export default __webpack_public_path__ + "static/media/B188.f06038bd.png";